import { useContext, useEffect } from "react"
import { useFormikContext } from "formik"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function HiddenDefault({ field, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    if (formik.values[field?.field_name] === "" && field?.field_default_value !== null) {
      formik.setFieldValue(field?.field_name, field?.field_default_value)
    } else {
      formik.setFieldValue(field?.field_name, formik.values[field?.field_name])
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field?.field_name}
        value={formik.values[field?.field_name]}
      />
    </div>
  )
}